import styled from 'styled-components';

const AnonymousModalLogin = styled.div<React.CSSProperties>`
  align-items: center;
  display: flex;
  flex-direction: column;
  width: fit-content;
`;

export default AnonymousModalLogin;
